import type { GetOrganisationWebhookOpenApiDocsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOrganisationWebhookOpenApiDocsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook, type StrictMappedGraphQLSelection } from 'src/utils';

import type { WebhookOpenApiDocsResult } from './types';

// The doc only changes on deploy, so cache aggressively and serve the download
// from memory rather than refetching on remount/focus.
const OPEN_API_DOCS_STALE_TIME_MS = 60 * 60 * 1000;

export const mapOpenApiDocsToGraphQL = (
  doc: WebhookOpenApiDocsResult
): StrictMappedGraphQLSelection<GetOrganisationWebhookOpenApiDocsQuery> => ({
  getOrganisationWebhookOpenApiDocs: {
    __typename: 'GetOrganisationWebhookOpenApiDocsOutput',
    document: doc,
  },
});

export const useGetWebhookOpenApiDocs = createQueryHook<
  undefined,
  WebhookOpenApiDocsResult,
  GetOrganisationWebhookOpenApiDocsQuery
>({
  trpcQueryOptions: (trpc) => trpc.frontend.webhook.openApiDocs.queryOptions(),
  mapTrpcDataToGraphQL: mapOpenApiDocsToGraphQL,
  graphqlDocument: GetOrganisationWebhookOpenApiDocsDocument,
  graphqlFetchPolicy: 'cache-first',
  trpcStaleTime: OPEN_API_DOCS_STALE_TIME_MS,
});
